import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import {
  getUserQuizApi,
  createUserQuizParticipationApi,
  submitUserQuizAnswerApi,
  submitUserQuizFeedbackApi,
} from "../../../../services/QuizService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularTimer from "../../../constant/CircularTimer";
import ParticipatonAnswers from "../ParticipatorAnswers";
import DisplayTopScorer from "../DisplayTopScorer";
const QuizDetailsLoading = () => {
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="w-100 px-2 mt-3">
            <Placeholder animation="glow">
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
            </Placeholder>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-item-center justify-content-between">
            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>

            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DisplayQuestionOption = ({
  handleOptionSelect,
  selectedOption,
  option,
  optionName,
}) => {
  return (
    <div className="form-check custom-checkbox mb-2 form-check-inline">
      <strong className="me-1">{optionName}.</strong>
      <input
        className="me-2 form-check-input"
        type="radio"
        id={optionName}
        name="option"
        value={option}
        checked={selectedOption === option}
        onChange={handleOptionSelect}
      />
      <label htmlFor={optionName} className="form-check-label">
        {option}
      </label>
    </div>
  );
};

const UserQuizDetails = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isParticipateLoading, setIsParticipateLoading] = useState(false);
  const [quiz, setQuiz] = useState(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuiz = async () => {
      setIsLoading(true);
      try {
        const response = await getUserQuizApi(id);
        const quizData = response.data.results;
        setQuiz(quizData);
        const participation = quizData?.participation;
        if (participation?.last_question_attend) {
          const question_number =
            participation?.last_question_attend.question_number;
          // if user submit feedback mean user alltend all question no need to set curentindex of question
          const is_completed_participation = participation.is_completed;
          const is_submitted_feedback = participation.feedback;

          if (is_submitted_feedback === null) {
            if (is_completed_participation) {
              setShowFeedbackForm(true);
            } else {
              const lastQuestionIndex = quizData.questions.findIndex(
                (item) => item.question_number === question_number
              );
              if (lastQuestionIndex !== -1) {
                setCurrentIndex(lastQuestionIndex + 1);
              }
            }
          }
        }
      } catch (error) {
        toast.error("Error fetching quiz!");
      }
      setIsLoading(false);
    };

    fetchQuiz();
  }, [id]);

  const handleParticipate = async () => {
    if (isParticipateLoading) {
      return;
    }
    setIsParticipateLoading(true);
    try {
      const response = await createUserQuizParticipationApi({
        quiz_id: quiz.id,
      });
      const data = response.data.results;
      setQuiz((prev) => ({ ...prev, participation: data }));
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setIsParticipateLoading(false);
    }
  };

  const handleOptionSelect = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
  };

  const handleNext = async () => {
    if (!selectedOption) {
      alert("Please select an option before proceeding.");
      return;
    }
    const currentQuestion = quiz.questions[currentIndex];
    const payload = {
      quiz_id: quiz.id,
      question_id: currentQuestion.id,
      answer: selectedOption,
    };
    await submitUserQuizAnswerApi(payload);

    if (currentIndex < quiz.questions.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
      setSelectedOption(""); // Reset selected option
    } else {
      setShowFeedbackForm(true);
    }
  };

  const handleSubmitFeedback = async () => {
    if (isParticipateLoading) {
      return;
    }
    setIsParticipateLoading(true);
    try {
      const response = await submitUserQuizFeedbackApi({
        quiz_id: quiz.id,
        feedback,
      });
      const data = response.data.results;
      setQuiz((prev) => ({ ...prev, participation: data }));
      setShowFeedbackForm(false);
      setFeedback("");
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setIsParticipateLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            {isLoading ? (
              <QuizDetailsLoading />
            ) : quiz !== null ? (
              <div className="card">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm btn-circle"
                        onClick={() => navigate("/quiz")}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <h4 className="mb-0 ms-2">Quiz Details</h4>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <h5>
                        <strong>Title: </strong>
                        {quiz.title}
                      </h5>
                      <p>
                        <strong>Description: </strong> {quiz.description}
                      </p>
                    </div>
                    <div>
                      <CircularTimer
                        publish_date={quiz.publish_date}
                        start_time={quiz.start_time}
                        end_time={quiz.end_time}
                      />
                    </div>
                  </div>

                  {quiz.is_result_published ? (
                    <div>
                      <div className="d-flex align-items-center justify-content-center">
                        {quiz.participation !== null && (
                          <div className="card border-success me-3">
                            <div className="card-body">
                              <h3>Your Score</h3>
                              <div className="">
                                <div className="my-3 d-flex align-items-center justify-content-between">
                                  <strong>Correct Answer </strong>{" "}
                                  <span className="badge light border-0 badge-success ms-2">
                                    {quiz.participation.score}
                                  </span>
                                </div>
                                <div className="my-3 d-flex align-items-center justify-content-between">
                                  <strong>Incorrect Answer </strong>
                                  <span className="badge light border-0 badge-danger ms-2">
                                    {quiz.participation.no_of_incorrect}
                                  </span>
                                </div>
                                <div className="my-3 d-flex align-items-center justify-content-between">
                                  <strong>Total Attends </strong>
                                  <span className="badge light border-0 badge-primary ms-2">
                                    {quiz.participation.no_question_attend}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <DisplayTopScorer quizId={quiz.id} />
                      </div>
                      {quiz.participation !== null && (
                        <ParticipatonAnswers
                          participantId={quiz.participation.id}
                        />
                      )}
                    </div>
                  ) : quiz.participation === null ? (
                    <div className="bg-light p-2 w-auto rounded">
                      <div className="d-flex align-items-center justify-content-center">
                        <div>
                          <h5>Quiz Participation</h5>
                          <p>Total {quiz.questions.length} Questions</p>
                          <button
                            className="btn btn-primary"
                            onClick={handleParticipate}
                            disabled={isParticipateLoading}
                          >
                            {isParticipateLoading
                              ? "Start Participating..."
                              : "Start Participate "}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {quiz.participation.feedback !== null ? (
                        <div className="bg-success text-white p-2 w-auto rounded">
                          <div className="d-flex align-items-center justify-content-center">
                            <div>
                              <h5 className="text-white">
                                Quiz Participation Completed
                              </h5>
                              <p>Please Wait for the result announcement</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          {!showFeedbackForm ? (
                            <div>
                              <h3>
                                Question{" "}
                                {quiz.questions[currentIndex].question_number}
                              </h3>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    quiz.questions[currentIndex].question_text,
                                }}
                              ></div>
                              <ul>
                                <li>
                                  <DisplayQuestionOption
                                    handleOptionSelect={handleOptionSelect}
                                    selectedOption={selectedOption}
                                    option={
                                      quiz.questions[currentIndex].option_1
                                    }
                                    optionName={"A"}
                                  />
                                </li>

                                <li>
                                  <DisplayQuestionOption
                                    handleOptionSelect={handleOptionSelect}
                                    selectedOption={selectedOption}
                                    option={
                                      quiz.questions[currentIndex].option_2
                                    }
                                    optionName={"B"}
                                  />
                                </li>
                                <li>
                                  <DisplayQuestionOption
                                    handleOptionSelect={handleOptionSelect}
                                    selectedOption={selectedOption}
                                    option={
                                      quiz.questions[currentIndex].option_3
                                    }
                                    optionName={"C"}
                                  />
                                </li>
                                <li>
                                  <DisplayQuestionOption
                                    handleOptionSelect={handleOptionSelect}
                                    selectedOption={selectedOption}
                                    option={
                                      quiz.questions[currentIndex].option_4
                                    }
                                    optionName={"D"}
                                  />
                                </li>
                              </ul>
                              <button
                                className="btn btn-outline-primary"
                                onClick={handleNext}
                                disabled={!selectedOption}
                              >
                                Next
                              </button>
                            </div>
                          ) : (
                            <div>
                              <h3>Feedback</h3>
                              <textarea
                                placeholder="Please provide your feedback"
                                value={feedback}
                                className="form-control"
                                onChange={(e) => setFeedback(e.target.value)}
                              />
                              <br />
                              <button
                                className="btn btn-primary"
                                onClick={handleSubmitFeedback}
                              >
                                Submit Feedback
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <h4 className="text-center text-danger">
                    ⚠️ Quiz Not Found!
                    <br /> ID {id}
                  </h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserQuizDetails;
